import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {  MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import instance from "@services/services";
const { clinicId } = getConstants()
const {MastersApi} = api

export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{items:MasterTableDataType[],totalcount:number}>>=>{
    const result = await instance.post(`${MastersApi.findRos}`,{...params,clinicId});
    return result.data;
}

export const getAllBodySystem: () => Promise<ResponseType<{bodySystemName:string,bodySystemId:number}[]>> = async () => {
    const result = await instance.get(`${MastersApi.getAllBodySystem}/${clinicId}`);
    return result.data;
}


export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveRos}`,params);
    return result.data;
}

